import React from 'react';
import {
  StyleSheet, View, ActivityIndicator, Text,
} from 'react-native';
import ViewShot from 'react-native-view-shot';
import isMobile from '../../../components/IsMobile';
import LineGraph from '../../../graphs/LineGraph';
import WidgetHeader from './WidgetHeader';
import Style from '../../../constants/Style';
import LineGraphMobile from '../../../graphs/LineGraphMobile';
import Colors from '../../../constants/Colors';
import { SolveAnalyticsWidgetProps } from '../Utils';
import CompareArrowsIcon from '../../../components/CompareArrowsIcon';

const OverallTickets = ({
  range, compareRange, viewShotRef, loading, data, comparisonData,
}: SolveAnalyticsWidgetProps) => <View
  style={Style.commonCardStyle}
  testID='sa-overall-tickets-raised-chart'
>
    <WidgetHeader
      title='Overall tickets raised'
      {...{ range, compareRange }}
      tooltipText='Number of tickets raised per day in selected date range'
    />
    <ViewShot ref={viewShotRef}>
      <View style={styles.ticketsCount}>
        <View style={Style.row}>
          <Text style={styles.countValue}>
            {data?.reduce((total, point) => (point.value ?? 0) + total, 0) ?? '-'}
          </Text>
          {comparisonData && <>
            <CompareArrowsIcon style={styles.compareIcon} />
            <Text style={[styles.countValue, styles.comparisonText]}>
              {comparisonData?.reduce((total, point) => (point.value ?? 0) + total, 0) ?? '-'}
            </Text>
          </>}
        </View>
        <Text style={styles.countLabel}>{'tickets'}</Text>
      </View>
      {isMobile ? <View style={styles.graphMobile}>
        <LineGraphMobile
          data={data?.map((point, index: number) => ({
            value: point.value, date: point.key, index,
          })) ?? []}
          comparisonData={comparisonData?.map((point, index: number) => ({
            value: point.value, date: point.key, index,
          })) ?? []}
        // dates={range}
        // compareToggled={!!compareRange.end}
        />
      </View> : <LineGraph
        chartData={data?.map((point, index: number) => ({
          value: point.value, date: point.key, index,
        }))}
        comparisonData={compareRange.end
          ? comparisonData?.map((point, index: number) => ({
            value: point.value, date: point.key, index,
          })) : null}
        title='Tickets raised'
        noTitle
        chartHeight={368}
        style={styles.graphWeb}
        noAxisLabel
      />}
      {loading ? <ActivityIndicator
        style={[StyleSheet.absoluteFill, { backgroundColor: '#00000020' }]}
        animating={loading}
        size={'large'}
      /> : null}
    </ViewShot>
  </View>;

const styles = StyleSheet.create({
  ticketsCount: {
    flexDirection: 'row',
    alignItems: 'flex-end',
    marginBottom: isMobile ? 80 : 40,
  },
  countValue: {
    fontSize: 30,
    lineHeight: isMobile ? undefined : 30,
    letterSpacing: 0,
    fontFamily: 'Poppins_600SemiBold',
    color: Colors.light.hereworksBlack600,
  },
  countLabel: {
    fontSize: 14,
    lineHeight: isMobile ? undefined : 14,
    letterSpacing: 0,
    fontFamily: 'Roboto_400Regular',
    color: Colors.light.hereworksBlack600,
    marginHorizontal: 4,
    marginBottom: isMobile ? 8 : 2,
  },
  graphMobile: {
    aspectRatio: 1,
    marginStart: -24,
    marginEnd: 64,
    marginTop: -54,
  },
  graphWeb: {
    marginTop: -70,
    marginBottom: -20,
    marginStart: -32,
  },
  compareIcon: {
    marginHorizontal: 4,
  },
  comparisonText: {
    color: Colors.light.hereworksYellow600,
  },
});

export default OverallTickets;
